"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MobilePageFrameFooter = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const Shell_1 = require("../Shell");
const clsx_1 = __importDefault(require("clsx"));
const CommonPageFrame_module_css_1 = __importDefault(require("./CommonPageFrame.module.css"));
const MobilePageFrameFooter_module_css_1 = __importDefault(require("./MobilePageFrameFooter.module.css"));
const CTAFooter_1 = require("../CTAFooter");
const web_blizzard_reporting_1 = require("@snapchat/web-blizzard-reporting");
const hooks_1 = require("../../utils/hooks");
const web_experiments_1 = require("@snapchat/web-experiments");
const MobileCTAFooterV2_1 = require("../MobileCTAFooterV2");
/**
 * Old mobile Page Frame footer
 */
function OldMobilePageFrameFooter({ webClientId, locale, localeChange, footerProps, footerExperimentProps, hideDefaultFooter, pageType, downloadUrl, }) {
    const DefaultCTAFooter = !hideDefaultFooter ? ((0, jsx_runtime_1.jsx)(CTAFooter_1.CTAFooter, { ...(footerProps ?? {}), locale: locale, downloadUrl: downloadUrl, localeChange: localeChange, webClientId: webClientId, pageType: pageType, isMobile: true })) : null;
    const shouldRunFooterExperiment = footerExperimentProps?.experimentEvaluator();
    const Footer = shouldRunFooterExperiment && footerExperimentProps ? ((0, jsx_runtime_1.jsx)(Shell_1.webConfigContext.Experiment, { configId: footerExperimentProps.experimentId(), webClientId: webClientId ?? "", pageTypeName: web_blizzard_reporting_1.PageType[pageType], children: ({ treatmentValue, hasFetchedConfigs, userHasOptedOutOfExperiments }) => ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: footerExperimentProps.experimentRenderer({
                control: DefaultCTAFooter,
                treatmentValue: treatmentValue,
                isLoading: !hasFetchedConfigs && !userHasOptedOutOfExperiments,
                userHasOptedOutOfExperiments: userHasOptedOutOfExperiments,
            }) })) })) : (DefaultCTAFooter);
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)("mobileOnly", CommonPageFrame_module_css_1.default.footerWrapper, MobilePageFrameFooter_module_css_1.default.mobileFooterWrapper), children: Footer }));
}
/**
 * New mobile Page Frame Footer
 */
function NewMobilePageFrameFooter({ newOISExperimentProps, mobilePageContainerRef, }) {
    const scrollDirection = (0, hooks_1.useScrollDirection)(mobilePageContainerRef);
    // eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain,@typescript-eslint/no-non-null-assertion
    const newFooterProps = newOISExperimentProps?.newFooterProps;
    return ((0, jsx_runtime_1.jsx)("div", { className: (0, clsx_1.default)("mobileOnly", CommonPageFrame_module_css_1.default.footerWrapper, MobilePageFrameFooter_module_css_1.default.mobileFooterV2Wrapper), children: (0, jsx_runtime_1.jsx)(MobileCTAFooterV2_1.MobileCTAFooterV2, { ...newFooterProps, scrollDirection: scrollDirection }) }));
}
/**
 * Experiment Wrapper for the new OIS experiment
 */
function NewOISExperimentMobilePageFrameFooter(props) {
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const newOISExperimentProps = props.newOISExperimentProps;
    const configId = newOISExperimentProps.configID;
    return ((0, jsx_runtime_1.jsx)(Shell_1.webConfigContext.Experiment, { configId: configId, webClientId: props.webClientId ?? "", pageTypeName: web_blizzard_reporting_1.PageType[props.pageType], onLogExposure: props.newOISExperimentProps?.onNewOISExperimentExposureLog, children: ({ treatmentValue, isLoading, userHasOptedOutOfExperiments }) => {
            if (isLoading) {
                // render w/o the footer when loading as we dont want the flicker
                return (0, jsx_runtime_1.jsx)(OldMobilePageFrameFooter, { ...props, hideDefaultFooter: true });
            }
            if (treatmentValue === web_experiments_1.TreatmentValue.Control || userHasOptedOutOfExperiments) {
                return (0, jsx_runtime_1.jsx)(OldMobilePageFrameFooter, { ...props });
            }
            return ((0, jsx_runtime_1.jsx)(NewMobilePageFrameFooter, { ...props, newOISExperimentProps: {
                    ...newOISExperimentProps,
                    newFooterProps: {
                        ...newOISExperimentProps.newFooterProps,
                        // @ts-ignore --- variant is skipped from MobilePageFrame's external contract but injected here internally. Remove once the AB is wrapped up
                        variant: treatmentValue === web_experiments_1.TreatmentValue.Treatment0
                            ? MobileCTAFooterV2_1.MobileCTAFooterV2Variant.PRIMARY_PAGE_COLOR
                            : MobileCTAFooterV2_1.MobileCTAFooterV2Variant.BLUE,
                    },
                } }));
        } }));
}
/**
 * The mobile version of the footer part of the page frame
 */
function MobilePageFrameFooter(props) {
    const FooterComponent = props.newOISExperimentProps?.enableNewOISExperiment
        ? NewOISExperimentMobilePageFrameFooter
        : OldMobilePageFrameFooter;
    return (0, jsx_runtime_1.jsx)(FooterComponent, { ...props });
}
exports.MobilePageFrameFooter = MobilePageFrameFooter;
//# sourceMappingURL=MobilePageFrameFooter.js.map